var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"input-group--focused",attrs:{"items":_vm.items,"item-value":"value","item-text":"text"},model:{value:(_vm.apiSelected),callback:function ($$v) {_vm.apiSelected=$$v},expression:"apiSelected"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19880e44","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/ApiSelect.vue
// module id = null
// module chunks = 